module.exports = __webpack_public_path__ + "img/page06_text.d3caf339.png";